import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from '@material-ui/core';

import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import { formatCurrency } from 'src/utils/currency';
import AmountAutoComplete from 'src/components/PurchaseOrderDetails/inputs/AmountAutoComplete';

const useStyles = makeStyles((theme) => ({
  dialogTitleConatiner: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
  },
  dialogTitleText: {
    color: theme.palette.getContrastText(theme.palette.primary.dark),
    fontSize: theme.typography.h3.fontSize,
  },
  datePickerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
  },
  valueField: {
    width: '150px',
    textAlign: 'right',
  },
}));

function SecondaryChargeInfoDialog({
  availableCharges,
  appliedCharges,
  isDialogOpen,
  setIsDialogOpen,
  handleApply,
  selectedCharge,
  setSelectedCharge,
  purchaseOrderDetails,
  isChargeReadOnly,
  providerCategory,
}) {
  const classes = useStyles();
  const FLAT_RATE_CREDIT_CARD_FEE = 1;
  const PERCENTAGE_CREDIT_CARD_FEE = 2;

  const [updatedFields, setUpdatedFields] = useState();
  const [chargeCategory, setChargeCategory] = useState(2);
  const [availableCreditCardFeeTypes, setAvailableCreditCardFeeTypes] = useState([
    { creditCardFeeTypeId: 1, creditCardTypeName: 'Flat Rate' },
    { creditCardFeeTypeId: 2, creditCardTypeName: 'Percentage' },
  ]);
  const [selectedCreditCardFeeTypeId, setSelectedCreditCardFeeTypeId] = useState(purchaseOrderDetails?.CreditCardFeeTypeId || 1);

  useEffect(() => handleSelectionChange(selectedCharge), [selectedCharge]);

  const changeChargeCategory = (selectedCatergoryId) => {
    if (chargeCategory !== selectedCatergoryId){
      setSelectedCharge(null);
    }
    setChargeCategory(selectedCatergoryId);
  };

  const handleClose = (reason) => {
    if (reason === 'escapeKeyDown' || reason === 'backdropClick') {
      return false;
    }
  };

  function handleSetFocus(e) {
    e.target.setSelectionRange(0, 0);
  }

  function handleKeyDown(e, updatedFields) {
    if (e.key === 'Enter') {
      e.stopPropagation();
      handleApplyAndClose(updatedFields);
    }
  }

  const handleApplyAndClose = (updatedFields) => {
    if (isCreditCardChargeSelected) {
      if (selectedCreditCardFeeTypeId === PERCENTAGE_CREDIT_CARD_FEE) {
        updatedFields[1].amount = 0;
      } else {
        updatedFields[0].amount = 0;
      }
    }

    handleApply(updatedFields);
      setTimeout(() => {
          setSelectedCharge(null);
          setIsDialogOpen(false);
      }, 50);
  }

  const isApplyAndCloseDisabled = () => {

    if (isCreditCardChargeSelected){
      if (updatedFields != null && updatedFields.length > 0){
        if (selectedCreditCardFeeTypeId === PERCENTAGE_CREDIT_CARD_FEE && 
          (updatedFields[0]?.amount != 0 && (updatedFields[0]?.amount < 0.25 || updatedFields[0]?.amount > 5.0))) {
          return true;
        }
      }
    }

    return !selectedCharge?.purchaseOrderChargeTypeId;
  } 


  const handleAmountChange = (name, value) => {
    value = value.replace(/[^0-9.]/g, '');
    const mutatedUpdatedFields = [...updatedFields];
    const modifiedFields = mutatedUpdatedFields.filter((o) => o.name == name);
    if (providerCategory != 'Out Of Network') {
      if (selectedCharge.purchaseOrderChargeTypeName == 'UnloadedMileageAmount') {
        modifiedFields[0].amount = value;
        const mileage = mutatedUpdatedFields[0];
        const free = mutatedUpdatedFields[1];
        const rate = mutatedUpdatedFields[2];
        const amount = mutatedUpdatedFields[3];
        const total = (Number(mileage.amount) - Number(free.amount)) * Number(rate.amount);

        amount.amount = formatCurrency(total).substring(1);
        setUpdatedFields(mutatedUpdatedFields);
        return;
      }

      if (selectedCharge.purchaseOrderChargeTypeName == 'LoadedMileageAmount') {
        modifiedFields[0].amount = value;

        const mileage = mutatedUpdatedFields[0];
        const free = mutatedUpdatedFields[1];
        const rate = mutatedUpdatedFields[2];
        const amount = mutatedUpdatedFields[3];
        const total = (Number(mileage.amount) - Number(free.amount)) * Number(rate.amount);

        amount.amount = formatCurrency(total).substring(1);
        setUpdatedFields(mutatedUpdatedFields);
        return;
      }

      if (selectedCharge.purchaseOrderChargeTypeName == 'StorageAmount') {
        modifiedFields[0].amount = value;

        const daysInStorage = mutatedUpdatedFields[0];
        const storageRate = mutatedUpdatedFields[1];
        const total = Number(daysInStorage.amount) * Number(storageRate.amount);
        const amount = mutatedUpdatedFields[2];
        amount.amount = formatCurrency(total).substring(1);
        setUpdatedFields(mutatedUpdatedFields);
        return;
      }
    }

    if (selectedCharge.purchaseOrderChargeTypeName == "CreditCardAmount") {
      if (name == 'CreditCardFeeAmount') {
        const ccFeeAmount = mutatedUpdatedFields[1];
        ccFeeAmount.amount = value;
      }else if (name == 'CreditCardFeePercent') {
        const ccPercentField = mutatedUpdatedFields[0];
        ccPercentField.errorMessage = '';
        if (value != 0 && (value < 0.25 || value > 5.0)) {
          ccPercentField.errorMessage = 'Percent must be between 0.25 and 5.0';
        }
        ccPercentField.amount = value;
      }

      setUpdatedFields(mutatedUpdatedFields);
      return;
    }

    if (modifiedFields.length > 0)
        modifiedFields[0].amount = value;

    setUpdatedFields(mutatedUpdatedFields);
  };


  function handleSelectionChange(charge) {
    if (!selectedCharge || !selectedCharge?.purchaseOrderChargeTypeId) {
      setUpdatedFields(null);
      return null;
    }

    const newUpdatedFields = [{ ...charge }];
    const existingAppliedAmounts = appliedCharges.filter(o => o?.purchaseOrderChargeTypeId == charge.purchaseOrderChargeTypeId);
    if (existingAppliedAmounts && existingAppliedAmounts.length > 0) {
      newUpdatedFields[0].amount = formatCurrency(existingAppliedAmounts[0].amount).substring(1);
    } else {
      newUpdatedFields[0].amount = '0.00';
    }

    if (charge.purchaseOrderChargeTypeName == 'UnloadedMileageAmount') {
      const unloadedMileageRate = purchaseOrderDetails.UnloadedMileageRate;
      const freeUnloadedMileage = purchaseOrderDetails.FreeUnloadedMiles;
      const unloadedMileage = purchaseOrderDetails.MilesUnloaded;
      newUpdatedFields.unshift({ name: 'UnloadedMileageRate', formattedName: 'Unloaded Mileage Rate', amount: unloadedMileageRate, isCalculated: true });
      newUpdatedFields.unshift({ name: 'UnloadedFreeMiles', formattedName: 'Free Unloaded Mileage', amount: freeUnloadedMileage, isCalculated: true });
      newUpdatedFields.unshift({ name: 'UnloadedMileage', formattedName: 'Total Unloaded Mileage', amount: unloadedMileage });
    }

    if (charge.purchaseOrderChargeTypeName == 'LoadedMileageAmount') {
      const loadedMileageRate = purchaseOrderDetails.LoadedMileageRate;
      const freeLoadedMileage = purchaseOrderDetails.FreeLoadedMiles;
      const loadedMileage = purchaseOrderDetails.MilesLoaded;
      newUpdatedFields.unshift({ name: 'LoadedMileageRate', formattedName: 'Loaded Mileage Rate', amount: loadedMileageRate, isCalculated: true });
      newUpdatedFields.unshift({ name: 'LoadedFreeMiles', formattedName: 'Free Loaded Mileage', amount: freeLoadedMileage, isCalculated: true });
      newUpdatedFields.unshift({ name: 'LoadedMileage', formattedName: 'Total Loaded Mileage', amount: loadedMileage });
    }

    if (charge.purchaseOrderChargeTypeName == 'StorageAmount') {
      if (charge.categoryId == "2") {
        const secondaryStorageDailyRate = purchaseOrderDetails.SecondaryStorageDailyRate;
        const secondaryStorageDays = purchaseOrderDetails.SecondaryStorageDays;

        newUpdatedFields.unshift({ name: 'SecondaryDailyStorageRate', formattedName: 'Secondary Daily Storage Rate', amount: secondaryStorageDailyRate});
        newUpdatedFields.unshift({ name: 'SecondaryDaysInStorage', formattedName: 'Secondary Days In Storage', amount: secondaryStorageDays });
      }
      else {
        const storageDailyRate = purchaseOrderDetails.StorageDailyRate;
        const storageDays = purchaseOrderDetails.StorageDays;

        newUpdatedFields.unshift({ name: 'DailyStorageRate', formattedName: 'Daily Storage Rate', amount: storageDailyRate });
        newUpdatedFields.unshift({ name: 'DaysInStorage', formattedName: 'Days In Storage', amount: storageDays });
      } 
    }

    if (charge.purchaseOrderChargeTypeName === "CreditCardAmount") {
      const feeTypeId = purchaseOrderDetails?.CreditCardFeeTypeId || FLAT_RATE_CREDIT_CARD_FEE;
      const percent = purchaseOrderDetails?.CreditCardFeePercent || "0.00";
      const flat = existingAppliedAmounts?.[0]?.amount || "0.00";
      setSelectedCreditCardFeeTypeId(feeTypeId);

      newUpdatedFields.unshift({ name: 'CreditCardFeeTypeId', formattedName: 'Credit Card Fee Type', amount: feeTypeId });
      newUpdatedFields.unshift({ name: 'CreditCardFeeAmount', formattedName: 'Flat Fee Amount', amount: flat });
      newUpdatedFields.unshift({ name: 'CreditCardFeePercent', formattedName: 'Credit Card Fee Percent (0.25% - 5.0%)', amount: percent });

      setUpdatedFields(newUpdatedFields);
      return;
    }

    changeChargeCategory(parseInt(charge.categoryId) ?? 2);
    setSelectedCharge(charge);
    setUpdatedFields(newUpdatedFields);
  }

  const filteredCharges = availableCharges?.filter(
    (charge) => charge.categoryId === chargeCategory?.toString()
  ) || [];

  const isCreditCardChargeSelected = selectedCharge?.purchaseOrderChargeTypeId === 10 || selectedCharge?.purchaseOrderChargeTypeName === 'CreditCardAmount';

  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={(_, reason) => handleClose(reason)}
        aria-labelledby="creditCardFeeDialog"
        aria-describedby="creditCardFeeDialog"
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle
          className={classes.dialogTitleConatiner}
          id="customDateRangePickerTitle"
          data-test="creditCardFeeDialogTitle"
          aria-label="creditCardFeeDialogTitle"
        >
          <Typography
            className={classes.dialogTitleText}
          >
            {isCreditCardChargeSelected ? 'Apply Credit Card Fee' : 'Modify Secondary Charge'}
          </Typography>
        </DialogTitle>
        <DialogContent >
        <Box display="flex" justifyContent="center" mb={2}>
        </Box>
          <Box className={classes.datePickerContainer}>
          {(!isCreditCardChargeSelected && chargeCategory) && (
            <AmountAutoComplete
              disabled={!isChargeReadOnly}
              availableCharges={filteredCharges}
              setSelectedCharge={setSelectedCharge}
              selectedCharge={selectedCharge}
            /> 
            )}
          </Box>
          {isCreditCardChargeSelected && updatedFields && (
            <>
            <Box className={classes.datePickerContainer}>
                <FormControl>
                <FormLabel id="credit-card-fee-type-radio-buttons-group-label">Select Credit Card Fee Type</FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="credit-card-fee-type-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel 
                    id="flatRateCreditCardFeeTypeRadioButton"
                    value="Flat Rate" 
                    control={<Radio />} 
                    label="Flat Rate"
                    checked={selectedCreditCardFeeTypeId === FLAT_RATE_CREDIT_CARD_FEE}
                    onChange={() => setSelectedCreditCardFeeTypeId(FLAT_RATE_CREDIT_CARD_FEE)}
                  />
                  <FormControlLabel
                    id="percentageCreditCardFeeTypeRadioButton"
                    value="Percentage"
                    control={<Radio />}
                    label="Percentage"
                    checked={selectedCreditCardFeeTypeId === PERCENTAGE_CREDIT_CARD_FEE}
                    onChange={() => setSelectedCreditCardFeeTypeId(PERCENTAGE_CREDIT_CARD_FEE)}
                  />
                </RadioGroup>
              </FormControl>
            </Box>
            <Table>
              <TableBody>
                {/* Flat Rate */}
                {selectedCreditCardFeeTypeId === FLAT_RATE_CREDIT_CARD_FEE && (
                  <TableRow key={"CreditCardFeeAmount_row"}>
                    <TableCell className={classes.fontWeightMedium}>Flat Fee Amount</TableCell>
                    <TableCell align="right">
                      <TextField
                        id="creditCardFeeFlatAmount"
                        className={classes.valueField}
                        variant="outlined"
                        autoFocus
                        onFocus={handleSetFocus}
                        value={updatedFields[1]?.amount || ""}
                        disabled={false}
                        error={!!updatedFields[1]?.errorMessage}
                        helperText={updatedFields[1]?.errorMessage || ''}
                        onChange={e => handleAmountChange("CreditCardFeeAmount", e.target.value)}
                        onKeyDown={e => handleKeyDown(e, updatedFields)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              $
                            </InputAdornment>
                          ),
                        }}
                      />
                    </TableCell>
                  </TableRow>)}
                  {selectedCreditCardFeeTypeId === PERCENTAGE_CREDIT_CARD_FEE && (
                  <TableRow key={"CreditCardFeePercent_row"}>
                    <TableCell className={classes.fontWeightMedium}>{updatedFields[0]?.formattedName}</TableCell>
                    <TableCell align="right">
                      <TextField
                        id="creditCardFeePercentAmount"
                        className={classes.valueField}
                        variant="outlined"
                        autoFocus
                        onFocus={handleSetFocus}
                        value={updatedFields[0]?.amount || ""}
                        disabled={false}
                        error={!!updatedFields[0]?.errorMessage}
                        helperText={updatedFields[0]?.errorMessage || ''}
                        onKeyDown={e => handleKeyDown(e, updatedFields)}
                        onChange={e => handleAmountChange("CreditCardFeePercent", e.target.value)}
                        inputProps={{
                          maxLength: 5,
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              %
                            </InputAdornment>
                          )
                        }}
                      />
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
            </>
          )}
          
          {(!isCreditCardChargeSelected && updatedFields) &&
            <Table>
              <TableBody>
                {updatedFields.map(o => (
                  <TableRow key={o.purchaseOrderChargeTypeId || o.name}>
                    <TableCell className={classes.fontWeightMedium}>{o.formattedName}</TableCell>
                    <TableCell align="right">
                      <TextField
                        className={classes.valueField}
                        variant="outlined"
                        autoFocus
                        onFocus={handleSetFocus}
                        value={o.amount}
                        disabled={o.isCalculated && providerCategory !== 'Out Of Network'}
                        error={!!o.errorMessage}
                        helperText={o.errorMessage || ''}
                        onKeyDown={e => handleKeyDown(e, updatedFields)}
                        onChange={event => handleAmountChange(o.name, event.target.value)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>}
        </DialogContent>
        <DialogActions
          className={classes.actionsContainer}
        >
          <Button
            id="closeDialogButton"
            color="primary"
            variant="contained"
            onClick={() => setIsDialogOpen(false)}
          >
            Close
          </Button>
          <Button
            id="applyDialogButton"
            color="primary"
            variant="contained"
            disabled={isApplyAndCloseDisabled()}
            onClick={() => handleApplyAndClose(updatedFields)}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

SecondaryChargeInfoDialog.propTypes = {
  availableCharges: PropTypes.arrayOf(PropTypes.shape({
    purchaseOrderChargeTypeId: PropTypes.number,
    purchaseOrderChargeTypeName: PropTypes.string,
    isCalculated: PropTypes.bool,
    isExternalEditable: PropTypes.bool,
    isInternalEditable: PropTypes.bool,
    categoryId: PropTypes.number,
  })),
  appliedCharges: PropTypes.arrayOf(PropTypes.shape({
    purchaseOrderChargeId: PropTypes.string,
    poNumber: PropTypes.number,
    purchaseOrderChargeTypeId: PropTypes.string,
    purchaseOrderChargeTypeName: PropTypes.string,
    amount: PropTypes.number,
    isCalculated: PropTypes.bool,
    isExternalEditable: PropTypes.bool,
    isInternalEditable: PropTypes.bool,
    categoryId: PropTypes.number,
  })),
  isDialogOpen: PropTypes.bool,
  setIsDialogOpen: PropTypes.func,
  handleCustomDateRangeSave: PropTypes.func,
  purchaseOrderDetails: PropTypes.shape({
    AmountOwed: PropTypes.number,
    LoadedMileageRate: PropTypes.number,
    MilesLoaded: PropTypes.number,
    FreeLoadedMiles: PropTypes.number,
    UnloadedMileageRate: PropTypes.number,
    MilesUnloaded: PropTypes.number,
    FreeUnloadedMiles: PropTypes.number,
    StorageDailyRate: PropTypes.number,
    StorageDays: PropTypes.number,
    SecondaryStorageDailyRate: PropTypes.number,
    SecondaryStorageDays: PropTypes.number,
  }),
  selectedCharge: PropTypes.shape({
    purchaseOrderChargeTypeId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    purchaseOrderChargeTypeName: PropTypes.string,
    isCalculated: PropTypes.bool,
    isExternalEditable: PropTypes.bool,
    isInternalEditable: PropTypes.bool,
    categoryId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
  }),
  setSelectedCharge: PropTypes.func,
  handleApply: PropTypes.func,
  isChargeReadOnly: PropTypes.bool,
  providerCategory: PropTypes.string,
};


export default SecondaryChargeInfoDialog;